
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getActivities",
      resolverType: "query",
      routePath: "/getActivities",
      httpMethod: "POST",
    });
  